const ss3 = (weight: number) => ({fontFamily: "'SS3', 'SourceSans3-Regular', sans-serif", fontWeight: weight as any});

const SourceSansPro_300Light     = ss3(300);
const SourceSansPro_400Regular   = ss3(400);
const SourceSansPro_500Medium    = ss3(500);
const SourceSansPro_600SemiBold  = ss3(600);
const SourceSansPro_700Bold      = ss3(700);
const SourceSansPro_800ExtraBold = ss3(800);
const SourceSansPro_900Black     = ss3(900);

export const fonts = {
  SourceSansPro_300Light,
  SourceSansPro_400Regular,
  SourceSansPro_500Medium,
  SourceSansPro_600SemiBold,
  SourceSansPro_700Bold,
  SourceSansPro_800ExtraBold,
  SourceSansPro_900Black,
};
